import { z } from 'zod';
import { PoolDtoZod, PoolType } from '../biz/PoolType';
import { httpApi } from './basicHttpApi';
import { ProxyPoolRotationSchema } from '../biz/proxyPoolRotationOptions';
import { ProxyPoolProtocolSchema } from '../biz/proxyPoolProtocolOptions';

export const CreateProxyPoolBodySchema = z.object({
  subscription_id: z.number(),
  pool_name: z.string(),
  countries_list: z.array(z.string()),
  cities_list: z.string().array().optional(),
  rotation: ProxyPoolRotationSchema,
  protocol: ProxyPoolProtocolSchema
});
type CreateProxyPoolBodyType = z.infer<typeof CreateProxyPoolBodySchema>;

export const fetchCreateProxyPool = async (
  body: CreateProxyPoolBodyType
): Promise<PoolType> => {
  const parsedBody = CreateProxyPoolBodySchema.parse(body);

  const result = await httpApi('pools/create', parsedBody);
  return PoolDtoZod.parse(result);
};
/*

http://139.162.187.132:10082/v1/pools/create
POST, пример запроса
{
    "subscription_id": 8,
    "countries_list": ["DE", "GB", "FR"],
    "pool_name": "basic_pool"
}

тестирование затянулось немного, но наконец готово.
в /v1/pools/create добавилось два поля, cities_list и states_list. Если передано больше одной страны и города/штаты не пустые, или если переданы одновременно штаты и города, то выдаст ошибку 400 bad request. Другими словами, допустимо: несколько стран, одна страна и несколько городов, одна страна и несколько штатов, одна страна без городов и штатов.
Также в /v1/proxy/generate добавлен параметр state, куда можно передать штат. Также города и штаты добавлены к dataimpulse прокси.


Всеслав Коченов
  4:35 PM
с моей стороны в ответах штаты должны приходить в lowercase и с нижним подчеркиванием вместо пробелов

*/
